import { createBrowserRouter } from 'react-router-dom';
import { createProtectedElement } from './components/ProtectedRoute';
import { RootErrorBoundary } from './pages/layout/error';
import RootLayout from './pages/layout/root';
import LotteryWheel from './pages/lottery-wheel';
import Landing from './pages/landing';
import ClaimPrize from './pages/claim-prize';

export const router = createBrowserRouter([
  {
    path: '/',
    ErrorBoundary: RootErrorBoundary,
    Component: RootLayout,
    children: [
      { index: true, element: <Landing /> },
      {
        path: 'wheel',
        element: <LotteryWheel />,
      },
      {
        path: 'claim-prize',
        element: <ClaimPrize />,
      },
      {
        path: '*',
        element: createProtectedElement(
          <div>Такая страница не существует</div>
        ),
      },
    ],
  },
]);
